import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const HistoryIcon: FC<
  IconProps & {
    startColor?: string;
    endColor?: string;
    active?: boolean;
  }
> = memo(
  ({
    active,
    width,
    height,
    size = 44,
    color = 'rgba(255, 255, 255, 0.4)',
    startColor,
    endColor,
    style,
  }) => {
    if (active) {
      return (
        <Svg
          width={width ?? size}
          height={height ?? size}
          viewBox="0 0 44 44"
          style={style}
        >
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.75 8.64288C14.1977 8.64288 13.75 8.19517 13.75 7.64288V3.14288H7.14288C4.93374 3.14288 3.14288 4.93375 3.14288 7.14289V36.8572C3.14288 39.0663 4.93375 40.8572 7.14289 40.8572H36.8572C39.0663 40.8572 40.8572 39.0663 40.8572 36.8572V7.14288C40.8572 4.93374 39.0663 3.14288 36.8572 3.14288H29.8572V7.64288C29.8572 8.19517 29.4095 8.64288 28.8572 8.64288H26.9286C26.3763 8.64288 25.9286 8.19517 25.9286 7.64288V3.14288H17.6786V7.64288C17.6786 8.19517 17.2309 8.64288 16.6786 8.64288H14.75ZM33.7933 14.4913C34.2104 14.8534 34.255 15.4849 33.8929 15.902L21.584 30.0814C20.3926 31.4538 18.2213 31.3137 17.2162 29.7996L13.1245 23.6358C12.8191 23.1757 12.9445 22.5551 13.4046 22.2496L15.0114 21.183C15.4715 20.8776 16.0921 21.003 16.3976 21.4631L19.6326 26.3364L30.9262 13.3267C31.2883 12.9096 31.9199 12.865 32.3369 13.227L33.7933 14.4913Z"
            fill="url(#paint0_linear_371_4438)"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_371_4438"
              x1="25.4286"
              y1="40.8572"
              x2="25"
              y2="5.71431"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor={startColor ?? color} />
              <Stop offset="1" stopColor={endColor ?? color} />
            </LinearGradient>
          </Defs>
        </Svg>
      );
    }

    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 44 44"
        fill="none"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.7282 13.9893C34.1453 14.3513 34.1899 14.9829 33.8278 15.4L21.5189 29.5794C20.3275 30.9518 18.1562 30.8117 17.1511 29.2976L13.0594 23.1338C12.754 22.6737 12.8794 22.0531 13.3395 21.7476L14.9463 20.681C15.4064 20.3755 16.027 20.5009 16.3325 20.9611L19.5675 25.8344L30.8611 12.8246C31.2232 12.4076 31.8548 12.363 32.2718 12.725L33.7282 13.9893Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.75 10.2143C14.1977 10.2143 13.75 9.76658 13.75 9.21429V7.85715H7.07146V37.7143H36.9286V7.85715H29.8572V9.21429C29.8572 9.76657 29.4095 10.2143 28.8572 10.2143H26.9286C26.3763 10.2143 25.9286 9.76658 25.9286 9.21429V7.85715H17.6786V9.21429C17.6786 9.76657 17.2309 10.2143 16.6786 10.2143H14.75ZM25.9286 3.92858H17.6786V3.35715C17.6786 2.80486 17.2309 2.35715 16.6786 2.35715H14.75C14.1977 2.35715 13.75 2.80486 13.75 3.35715V3.92858H6.28574C4.54999 3.92858 3.14288 5.33568 3.14288 7.07143V38.5C3.14288 40.2358 4.54999 41.6429 6.28574 41.6429H37.7143C39.4501 41.6429 40.8572 40.2358 40.8572 38.5V7.07143C40.8572 5.33568 39.4501 3.92858 37.7143 3.92858H29.8572V3.35715C29.8572 2.80486 29.4095 2.35715 28.8572 2.35715H26.9286C26.3763 2.35715 25.9286 2.80486 25.9286 3.35715V3.92858Z"
          fill={color}
        />
      </Svg>
    );
  },
);
